import type { FC } from 'react';
import { TrackerTypeTag } from './TrackerTypeTag';

interface Props {
  width?: number;
}

export const UnusedTrackerTypeTag: FC<Props> = ({ width = 60 }) => {
  return (
    <TrackerTypeTag
      color="red"
      title="The device is unused. Tracker management is not charged for this device. All features of tracker management are usable and with usage, tracker management becomes chargeable for this device."
      width={width}
    >
      unused
    </TrackerTypeTag>
  );
};
